import { useState } from 'react';
import { MotionConfig } from 'framer-motion';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import MarqueeSection from './MarqueeSection';
import ServicesSection from './ServicesSection';
import MusicPlayer from './MusicPlayer';
import AboutSection from './AboutSection';
import SocialSection from './SocialSection';
import FooterSection from './FooterSection';
import ChatbotWidget from './ChatbotWidget';
import { Headphones } from 'lucide-react';
import './LandingPage.css';

const LandingPage = () => {
  const [showChatbot, setShowChatbot] = useState(false);

  return (
    <MotionConfig reducedMotion="user">
    <div className="landing-page" data-testid="landing-page">
      <Navbar onOpenChat={() => setShowChatbot(true)} />
      <HeroSection onOpenChat={() => setShowChatbot(true)} />
      <MusicPlayer />
      <MarqueeSection />
      <ServicesSection onOpenChat={() => setShowChatbot(true)} />
      <AboutSection />
      <SocialSection />
      <FooterSection />
      
      <ChatbotWidget 
        isOpen={showChatbot} 
        onClose={() => setShowChatbot(false)} 
      />
      
      {/* Floating chat button with music icon */}
      {!showChatbot && (
        <button 
          className="floating-chat-btn"
          onClick={() => setShowChatbot(true)}
          aria-label="Chat with K Beats AI"
          data-testid="chatbot-trigger"
        >
          <Headphones size={28} strokeWidth={2.5} />
        </button>
      )}
    </div>
    </MotionConfig>
  );
};

export default LandingPage;
